import React from 'react';
import Skeleton from '@wconcept/wconcept-ui-renewal/components/atoms/Skeleton';
import * as S from './style';

const HomeSkeleton = () => (
  <S.Box>
    <Skeleton className="main-banner" />
    <ul className="main-banner-pc">
      <li>
        <Skeleton className="thum" />
      </li>
      <li>
        <Skeleton className="thum" />
      </li>
      <li>
        <Skeleton className="thum" />
      </li>
      <li>
        <Skeleton className="thum" />
      </li>
      <li>
        <Skeleton className="thum" />
      </li>
    </ul>
    <div className="box-quick">
      <ul className="list">
        <Skeleton as="li" className="item" />
        <Skeleton as="li" className="item" />
        <Skeleton as="li" className="item" />
        <Skeleton as="li" className="item" />
        <Skeleton as="li" className="item" />
        <Skeleton as="li" className="item" />
      </ul>
      <ul className="list">
        <Skeleton as="li" className="item" />
        <Skeleton as="li" className="item" />
        <Skeleton as="li" className="item" />
        <Skeleton as="li" className="item" />
        <Skeleton as="li" className="item" />
      </ul>
    </div>
    <Skeleton className="cont-title" />
    <div className="box-prd">
      <ul className="list">
        <li className="item">
          <Skeleton className="thum" />
          <Skeleton className="text01" />
          <Skeleton className="text02" />
        </li>
        <li className="item">
          <Skeleton className="thum" />
          <Skeleton className="text01" />
          <Skeleton className="text02" />
        </li>
        <li className="item">
          <Skeleton className="thum" />
          <Skeleton className="text01" />
          <Skeleton className="text02" />
        </li>
      </ul>
      <ul className="list">
        <li className="item">
          <Skeleton className="thum" />
          <Skeleton className="text01" />
          <Skeleton className="text02" />
        </li>
        <li className="item">
          <Skeleton className="thum" />
          <Skeleton className="text01" />
          <Skeleton className="text02" />
        </li>
        <li className="item">
          <Skeleton className="thum" />
          <Skeleton className="text01" />
          <Skeleton className="text02" />
        </li>
      </ul>
    </div>
  </S.Box>
);

export default HomeSkeleton;
